'use client'

import { useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { clickEvent } from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import ExtendShippingDeadlineModal from '../ExtendShippingDeadlineModal'

type Props = ConversationActionProps

const ExtendShippingDeadline = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const trackButtonClick = () => {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'extend_shipping_deadline',
        screen: 'message_reply',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const handleModalOpen = () => {
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const handleClick = () => {
    trackButtonClick()

    handleModalOpen()
  }

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        onClick={handleClick}
      />
      <ExtendShippingDeadlineModal isOpen={isModalOpen} onClose={handleModalClose} />
    </>
  )
}

export default ExtendShippingDeadline
